module.exports = __webpack_public_path__ + "static/img/gt.b94c286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/mipmap-xxxhdpi/gt.png
// module id = X517
// module chunks = 18